angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('pl_PL', {"Auto-assign shifts to save hours of work!":"Automatycznie przypisz zmiany aby zaoszczędzić godziny pracy!","Cancel":"Anuluj","Select language":"Wybierz język","{{ clientFlagsExpanded ? 'Collapse' : 'Expand' }} client flags":"{{ clientFlagsExpanded ? 'Zwiń' : 'Rozwiń' }} flagi"});
/* jshint +W100 */
}]);